<template>
  <div class="inline-block relative">
    <select :name="name" :id="id" :disabled="disabled" class="select" :class="selectClass"
            v-model="selectedValue" @change="changeValue">
      <slot></slot>
    </select>
    <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
      <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: [
    'selected',
    'name',
    'id',
    'disabled',
    'selectClass'
  ],
  watch: {
    selected () {
      this.selectedValue = this.selected
    }
  },
  data () {
    return {
      selectedValue: this.selected
    }
  },
  methods: {
    changeValue (e) {
      this.$emit('change', this.selectedValue)
    }
  },
  computed: {
    classList () {
      return {
        'select': true
      }
    }
  }
}
</script>
